import { reducerTypes } from "./types";
import { IPageInfo } from "../../interfaces/common";
import { IContactUs } from "../../interfaces/contactUs";

export const getAllContactUsAction = (data: IContactUs[]) => ({
  type: reducerTypes.GET_ALL_CONTACTUS,
  payload: data,
});

export const getMoreContactUsAction = (data: IContactUs[]) => ({
  type: reducerTypes.GET_MORE_CONTACTUS,
  payload: data,
});

export const getContactUsAction = (data: IContactUs) => ({
  type: reducerTypes.GET_CONTACTUS,
  payload: data,
});

export const setSizePageAction = (page: IPageInfo) => ({
  type: reducerTypes.SET_PAGE_INFO,
  payload: page,
});
